import React from 'react';
import cn from 'clsx';
import { ModalContent } from 'fronton-react';
import { css } from 'linaria';
import {
  ButtonWithGAClickButton,
  List,
  ModalContentAction,
  ModalHeader,
  Typography,
} from 'common/components';
import { KITCHEN_SIGN_UP_HREF, KITCHEN_ELEMENT_BLOCK } from '../../../../../kitchen-constants';

const servicesModalText = css`
  margin-bottom: 8px;
`;

const servicesModalListText = css`
  margin-bottom: 4px;
`;

const servicesModalList = css`
  li:not(:last-child) {
    margin-bottom: 4px;
  }
`;

type ServicesModalProps = {
  regionId: string;
};

export const ServicesModal = ({ regionId }: ServicesModalProps) => (
  <>
    <ModalHeader title="Услуги Лемана ПРО" />
    <ModalContent>
      <Typography className={servicesModalText} variant="m" size="body_long">
        Мы&nbsp;реализуем проект вашей кухни под ключ. Вы&nbsp;можете оформить доставку до&nbsp;дома
        в&nbsp;удобное время или самостоятельно забрать покупки из&nbsp;ближайшего магазина. Пришлём мастеров
        для любого этапа работы.
      </Typography>
      <Typography className={servicesModalListText} variant="m" size="body_long">
        Наши услуги:
      </Typography>
      <List className={cn(servicesModalList, servicesModalText)} listStyle="disc">
        <li>
          <Typography variant="m" size="body_long">
            замер помещения
          </Typography>
        </li>
        <li>
          <Typography variant="m" size="body_long">
            сборка и&nbsp;установка кухонь
          </Typography>
        </li>
        <li>
          <Typography variant="m" size="body_long">
            установка крана на&nbsp;мойку
          </Typography>
        </li>
        <li>
          <Typography variant="m" size="body_long">
            монтаж фильтров для воды под мойку
          </Typography>
        </li>
        <li>
          <Typography variant="m" size="body_long">
            распил столешницы под нужный размер
          </Typography>
        </li>
      </List>
      <Typography variant="m" size="body_long">
        Все услуги выполняют проверенные мастера от&nbsp;наших партнёров.
      </Typography>
      <ModalContentAction>
        <ButtonWithGAClickButton
          adaptive={false}
          elementBlock={KITCHEN_ELEMENT_BLOCK}
          elementName="Услуги Лемана ПРО / modal"
          elementText="Записаться"
          href={`${KITCHEN_SIGN_UP_HREF}${regionId}`}
          target="_blank"
          wide>
          Записаться
        </ButtonWithGAClickButton>
      </ModalContentAction>
    </ModalContent>
  </>
);
